const DropDown = ({entity, name, options=[], valueAttr="id", labelAttr="label", changeHandler}) => {

    const changeHandlerWrapper = (event) => {
        const {value} = event.target
        changeHandler(entity.id, name, value)
    }

    return (
        <select
            value={entity[name]}
            onChange={changeHandlerWrapper}
        >
            <option value=""></option>
            {options.map(opt =>
                <option
                    key={opt[valueAttr]}
                    value={opt[valueAttr]}
                >
                    {opt[labelAttr]}
                </option>
            )}
        </select>
    )
}

export default DropDown